import React from "react";
import { Outlet, Link } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import styles from "./Shishka.module.css";
import Main from "./Main";

const Shishka = () => {
  return (
    <div className={styles.container}>
      <Header />
      <Outlet /> {/* This renders Setup.js or Main.js based on the route */}
      <Footer />
    </div>
  );
};

export default Shishka;
